import { LayoutList } from 'lucide-react';
import { ADMIN_GUARD } from '../admin-guard';
import { CONTEXTS, lazyView, type FeatureManifest } from '@/app/registry';
import { adminPromoCodesRoutes } from './routes';

export const adminPromoCodesManifest: FeatureManifest = {
  id: 'admin-promo-codes',
  contexts: [CONTEXTS.ADMIN_PROMO_CODES, CONTEXTS.ADMIN_PROMO_CODE_FORM],

  routes: [
    { routes: adminPromoCodesRoutes, errorFallbackLabel: 'Codes promo', guard: ADMIN_GUARD },
  ],

  centerView: {
    [CONTEXTS.ADMIN_PROMO_CODES]: lazyView(
      () => import('../views/AdminPromoCodesListView'),
      'AdminPromoCodesListView',
    ),
    [CONTEXTS.ADMIN_PROMO_CODE_FORM]: lazyView(
      () => import('../views/AdminPromoCodeFormView'),
      'AdminPromoCodeFormView',
    ),
  },

  panels: {
    left: {
      tabs: {
        [CONTEXTS.ADMIN_PROMO_CODES]: [
          {
            id: 'admin-nav',
            label: 'Navigation',
            icon: LayoutList,
            view: lazyView(() => import('../views/AdminNavView'), 'AdminNavView'),
          },
        ],
        [CONTEXTS.ADMIN_PROMO_CODE_FORM]: [
          {
            id: 'admin-nav',
            label: 'Navigation',
            icon: LayoutList,
            view: lazyView(() => import('../views/AdminNavView'), 'AdminNavView'),
          },
        ],
      },
    },
  },

  enabledWhen: {
    roles: ['admin'],
  },

  panelRequirements: {
    [CONTEXTS.ADMIN_PROMO_CODES]: {
      left: { open: true, defaultActiveTab: 'admin-nav' },
      right: { open: false },
    },
    [CONTEXTS.ADMIN_PROMO_CODE_FORM]: {
      left: { open: true, defaultActiveTab: 'admin-nav' },
      right: { open: false },
    },
  },
};
